const getters = {
  is_readjyagrt: state => state.loginInfo.is_readjyagrt,
  loginInfo: state => state.loginInfo,
  configTextList: state => state.configTextList,
};
export default getters;
